import { Component, OnInit, ViewChild } from '@angular/core';
import { ClassType } from './shared/class-type.model';
import { ClassTypeService } from './shared/class-type.service';
import { UtilService } from '../../shared/util/util.service';
import { NotificationService } from '../../shared/notification/notification.service';
import { TranslationService } from '../../shared/translation/translation.service';
import { DialogService, DatagridService } from '../../shared/index';
import { AsyncState } from '../../shared/model/index';
import { ProfileRead } from '../../profiles/shared/profile-read.model';

@Component({
  selector: 'wl-class-type-edit',
  templateUrl: 'class-type-edit.component.html',
  styleUrls: ['class-type-edit.component.css'],
  providers: [ClassTypeService],
    standalone: false
})
export class ClassTypeEditComponent implements OnInit {
  public _utilService: UtilService;
  public _classTypeService: ClassTypeService;
  public _notifyService: NotificationService;
  public _translationService: TranslationService;
  public _dataGridService: DatagridService;
  public _classTypeToDelete: number;

  public isSearching: boolean;
  public loadingClassType: AsyncState;

  public saving: boolean;
  public savingError: string;

  public editing: boolean;

  public loadingClassTypes: boolean;
  public loadingClassTypesError: string;

  public deleting: boolean;
  public deleteError: string;

  public selectedClassType: ClassType;

  public classType: ClassType;
  public classTypes: Array<ClassType>;

  public searchResult: any;
  public searchParams: any;

  public showClassTypeModal = false;
  public showDeleteModal = false;

  public constructor(
    utilService: UtilService,
    classTypeService: ClassTypeService,
    notifyService: NotificationService,
    translationService: TranslationService,
    dataGridService: DatagridService
  ) {
    this._classTypeService = classTypeService;
    this._utilService = utilService;
    this._notifyService = notifyService;
    this._translationService = translationService;
    this._dataGridService = dataGridService;
    this._classTypeToDelete = -1;

    this.loadingClassTypes = false;
    this.loadingClassTypesError = '';

    this.isSearching = false;

    this.classType = new ClassType();
    this.classTypes = new Array<ClassType>();

    this.editing = false;

    this.deleting = false;
    this.deleteError = '';

    this.searchResult = {};

    this.loadingClassType = new AsyncState();

    this.saving = false;
    this.savingError = '';
    this.selectedClassType = new ClassType();

    this.searchParams = { Keyword: '', PageSize: 10, OrderBy: 'ClassType1' };
  }

  ngOnInit() {}

  public lazyLoadClassTypes = ($event: any): void => {
    this._dataGridService.mapDatagridPagingToPagedSearch($event, this.searchParams);

    this.loadClassTypes(this.searchParams);
  };

  public newClassType = (): void => {
    this.saving = false;
    this.savingError = '';

    this.loadingClassType.busy = false;
    this.loadingClassType.message = '';

    let newClassType: ClassType = new ClassType();
    this.selectedClassType = newClassType;
    this.showClassTypeModal = true;
  };

  public loadClassTypes(searchParams: any) {
    this.loadingClassTypes = true;
    this.loadingClassTypesError = '';

    this._classTypeService
      .getClassTypes(searchParams)
      .then((data: any) => {
        this.loadingClassTypes = false;
        this.classTypes = data.Result;
        this.searchResult = data;
        if (this.classTypes.length > 0) {
          this.selectedClassType = this.classTypes[0];
        }
      })
      .catch(error => {
        this.loadingClassTypes = false;
        this.loadingClassTypesError = this._utilService.extractErrorMessage(error);
      });
  }

  public saveClassTypes = (): void => {
    this.saving = true;
    this.savingError = '';

    if (this.selectedClassType.ClassTypeId > 0) {
      this._classTypeService
        .updateClassType(this.selectedClassType)
        .then(() => {
          this.saving = false;

          this.loadClassTypes(this.searchParams);
          this.showClassTypeModal = false;

          this._translationService.get('common.success').then(translation => this._notifyService.success(translation));
        })
        .catch(error => {
          this.saving = false;
          this.savingError = this._utilService.extractErrorMessage(error);
        });
    } else {
      this._classTypeService
        .createClassType(this.selectedClassType)
        .then(() => {
          this.saving = false;

          this.loadClassTypes(this.searchParams);
          this.showClassTypeModal = false;

          this._translationService.get('common.success').then(translation => this._notifyService.success(translation));
        })
        .catch(error => {
          this.saving = false;
          this.savingError = this._utilService.extractErrorMessage(error);
        });
    }
  };

  public editClassType = (id: number): void => {
    this.saving = false;
    this.savingError = '';

    this.editing = true;

    this.loadingClassType.busy = true;
    this.loadingClassType.message = '';
    this.loadingClassType.success = false;

    this.showClassTypeModal = true;
    this._classTypeService
      .getClassType(id)
      .then(data => {
        this.loadingClassType.busy = false;
        this.loadingClassType.success = true;
        this.selectedClassType = data;
      })
      .catch(error => {
        this.loadingClassType.busy = false;
        this.loadingClassType.message = this._utilService.extractErrorMessage(error);
        this.loadingClassType.success = false;
      });
  };

  public confirmDeleteClassType(id: number): void {
    this.deleting = false;
    this.deleteError = '';
    this._classTypeToDelete = id;
    this.showDeleteModal = true;
  }

  public deleteClassType = (): void => {
    this.deleting = true;
    this.deleteError = '';

    this._classTypeService
      .deleteClassType(this._classTypeToDelete)
      .then(() => {
        this.deleting = false;
        this.showDeleteModal = false;
        this.loadClassTypes(this.searchParams);
      })
      .catch(error => {
        this.deleting = false;
        this.deleteError = this._utilService.extractErrorMessage(error);
      });
  };

  public isClassTypeEmpty = (): boolean => {
    return this.selectedClassType.ClassType.trim() == '';
  };
}
